export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="border-b border-gray-200 px-4 md:px-6 lg:px-10 py-5 md:py-8 flex flex-col md:flex-row md:items-start md:justify-between gap-4 bg-white">
      <div className="min-w-0">
        <div className="text-[10px] tracking-[0.25em] uppercase text-gray-400 font-medium mb-2">
          Showroom Finance
        </div>
        <h1 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight leading-tight break-words">
          {title}
        </h1>
        {subtitle && <div className="mt-2 text-sm text-gray-600">{subtitle}</div>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
